import {
    I18NData,
    I18NPayload,
    I18N_LANGUAGE
} from "./types";

export const setI18NLanguage = (data: I18NData): I18NPayload => ({
    type: I18N_LANGUAGE,
    data
});
